<template>
    <transition name="list-enter-up" appear @after-enter="disableTransitionDelay">
        <tr
            ref="tableTr"
            :style="rowStyles"
            :class="[
                `tr-table-state-${state}`,
                {
                    'is-selected': isSelected,
                    'selected': data,
                    'is-expand': maxHeight != '0px',
                    'activeEdit': activeEdit,
                    'hoverFlat': parent.hoverFlat
                }
            ]"
            class="tr-values vs-table--tr"
            @dblclick="dblclicktr"
            @mousedown="prepareInput"
            @mouseup="checkAndFireInput"
            @mouseleave="clearCurrentClick"
        >
            <vx-td
                v-if="parent.multiple || $slots.expand || parent.hasExpandableData"
                :class="{ 'active-expanded': expanded }"
                class="td-check"
            >
                <vs-checkbox
                    v-if="parent.multiple"
                    :checked="isSelected"
                    size="small"
                    @change="handleCheckbox"
                />

                <vx-action-icon
                    v-if="$slots.expand"
                    hover-color="primary"
                    class="vs-icon"
                    icon="ChevronDownIcon"
                />
            </vx-td>
            <slot></slot>
        </tr>
    </transition>
</template>

<script>
import Vue from 'vue'
import trExpand from './VxTrExpand'
import { findClosestParent } from '../../../assets/utils/components'
const transitionMultiplier = 0.015

export default {
    name: 'vx-tr',
    props: {
        state: {
            type: String,
            default: null
        },
        data: {
            default: null
        },
        index: {
            type: Number,
            default: 0
        }
    },
    data: () => ({
        colspan: 0,
        expanded: false,
        maxHeight: '0px',
        activeEdit: false,
        currentClick: null,
        initialAnimationComplete: false
    }),
    computed: {
        styleExpand() {
            return {
                maxHeight: this.maxHeight
            }
        },
        getColspanExpand() {
            let lengthx = this.parent.$refs.colgroup.querySelectorAll('th').length
            return lengthx
        },
        isSelected() {
            if (this.parent.multiple && this.parent.value) {
                return this.data
                    ? this.parent.value.some(
                          (item) => JSON.stringify(item) === JSON.stringify(this.data)
                      )
                    : false
            } else {
                return this.data ? this.parent.value == this.data : false
            }
        },
        parent() {
            return findClosestParent(this, 'vx-table')
        },
        rowStyles() {
            var delay = 0
            if (!this.initialAnimationComplete) {
                delay = this.index * transitionMultiplier
            }
            return {
                'transition-delay': `${delay}s`
            }
        }
    },
    watch: {
        'parent.datax'() {
            this.collapseExpandedData()
        }
    },
    methods: {
        disableTransitionDelay(index) {
            this.initialAnimationComplete = true
        },
        prepareInput(evt) {
            if (this.tryExpand(evt)) {
                return
            }
            this.currentClick = evt
        },
        clearCurrentClick(evt) {
            this.currentClick = null
        },
        checkAndFireInput(evt) {
            if (this.currentClick == null) {
                return
            }
            var diffX = Math.abs(this.currentClick.pageX - evt.pageX)
            var diffY = Math.abs(this.currentClick.pageY - evt.pageY)
            this.currentClick = null

            if (diffX > 5 || diffY > 5) {
                return
            }
            this.fireInput(evt)
        },
        handleCheckbox() {
            this.parent.handleCheckbox(this.data)
        },
        insertAfter(e, i) {
            if (e.nextSibling) {
                e.parentNode.insertBefore(i, e.nextSibling)
            } else {
                e.parentNode.appendChild(i)
            }
        },
        fireInput(evt) {
            this.$emit('click')
            this.parent.clicktr(this.data, true)
        },
        dblclicktr() {
            this.parent.dblclicktr(this.data, true)
        },
        tryExpand(evt) {
            if (this.parent.multiple || !this.$slots.expand) {
                return false
            }
            if (this.parent.$parent.$listeners['input'] && !evt.target.closest('.td-check')) {
                return false
            }
            let tr = evt.target.closest('tr')
            if (this.expanded) {
                tr.parentNode.removeChild(tr.nextSibling)
                tr.classList.remove('tr-expandedx')
                this.expanded = false
            } else {
                tr.classList.add('tr-expandedx')
                let trx = Vue.extend(trExpand)
                let instance = new trx({ parent: this, propsData: { colspan: this.colspan } })
                instance.$slots.default = this.$slots.expand
                instance.vm = instance.$mount()
                var newTR = document.createElement('tr').appendChild(instance.vm.$el)
                this.insertAfter(tr, newTR)
                this.expanded = true
            }
            return true
        },
        collapseExpandedData() {
            if (this.expanded) {
                const tr = this.$refs.tableTr
                tr.parentNode.removeChild(tr.nextSibling)
                tr.classList.remove('tr-expandedx')
                this.expanded = false
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            if (this.parent.$refs.thead) {
                this.colspan = this.parent.$refs.thead.querySelectorAll('th').length
            }
            if (this.$slots.expand) {
                this.colspan++
            }
        })
    },
    created() {
        if (this.$slots.expand) {
            this.parent.hasExpandableData = true
        }
    }
}
</script>
